import React from "react"
import {
  Flex, Heading, IconButton, Text,
} from "@chakra-ui/react"
import Icon from "components/elements/Icon"
import { MenuItem } from "components/dialogs/Menu"
import EditableFilter from "./EditableFilter"
import Filter from "./Filter"

type Props = {
  label: string;
  filters: any[];
  editable?: boolean;
  onAdd?: () => void;
  onCloseMenu: () => void;
}

const FilterGroup = ({
  label, filters, editable, onAdd, onCloseMenu,
}: Props) => {
  let filtersSection
  if (editable) {
    if (!filters.length) {
      filtersSection = (
        <MenuItem onClick={onAdd} fontSize="md" px={4} py={2.5}>
          <Flex align="center" w="full">
            <Icon icon="circle" size={3} mr={2} flexShrink={0} />
            <Text fontStyle="italic" color="gray.600">Create a filter defined by custom rules</Text>
          </Flex>
        </MenuItem>
      )
    } else {
      filtersSection = filters.map(({ key, ...filter }) => (
        <EditableFilter key={key} {...filter} onCloseMenu={onCloseMenu} />
      ))
    }
  } else {
    filtersSection = filters.map((filter) => <Filter key={filter.key} {...filter} />)
  }

  return (
    <>
      <Flex justify="space-between" align="center" w="full" px={4} borderBottomWidth={1}>
        <Heading fontSize="md" fontWeight="semibold" py={2.5}>{label}</Heading>
        {onAdd && (
          <IconButton
            aria-label="Add filter"
            icon={<Icon color="blue.500" icon="plus" />}
            variant="ghost"
            size="xs"
            borderRadius="md"
            _hover={{ bg: "gray.200" }}
            onClick={() => { onCloseMenu(); onAdd() }}
          />
        )}
      </Flex>
      {filtersSection}
    </>
  )
}

export default FilterGroup
